import React, { useState } from "react"
import Note from "@kit/design/note"
import { calloutMap } from "./utils/callout-map"
import { analytics } from "utils/analytics"
import { PlanComparison } from "app/shared/components/plan-comparison"

const trackClick = () => {
  analytics.track(
    "Element",
    "Clicked",
    {
      name: "profile_dropdown_upgrade_now",
      text: "Upgrade now",
      location: "vertical_nav"
    },
    { transport: "beacon" }
  )
}

// Vertical-nav port of the old UpgradeCallout. Same logic (driven by
// calloutMap), same interactions (navigate vs. open PlanComparison, celebration
// reload) and same analytics — only with `location: "vertical_nav"` added.
//
// `onModalOpenChange` lets the host keep the account menu mounted while the
// PlanComparison modal is open: the DS Menu (base-ui) unmounts its content on
// close, which would otherwise tear down the modal rendered here.
export function NewUpgradeCallout({ user, onModalOpenChange }) {
  const [
    showCallout,
    calloutLink,
    calloutContent,
    openPlanComparison,
    planComparisonModalContent
  ] = calloutMap(user)
  const [showPlanComparison, setShowPlanComparison] = useState(false)

  if (!showCallout) {
    return null
  }

  const setModalOpen = open => {
    setShowPlanComparison(open)
    onModalOpenChange?.(open)
  }

  const handleClick = e => {
    if (openPlanComparison) {
      e.preventDefault()
      setModalOpen(true)
    }

    trackClick()
  }

  const handleCelebration = () => {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "button",
        name: "learn_more_upgrade_callout",
        text: "Learn more",
        location: "vertical_nav"
      },
      { transport: "beacon" }
    )

    window.location.reload()
  }

  return (
    <>
      <Note
        type="info"
        icon={false}
        title={calloutContent.header}
        message={calloutContent.text}
        className="mb-1"
        action={{
          label: calloutContent.buttonText,
          href: openPlanComparison ? undefined : calloutLink,
          onClick: handleClick,
          telemetry: false
        }}
      />
      {showPlanComparison && (
        <PlanComparison
          title={planComparisonModalContent.title}
          description={planComparisonModalContent.description}
          serviceLevels={planComparisonModalContent.plans}
          onClose={() => setModalOpen(false)}
          afterCelebration={handleCelebration}
          prioritizedServiceLevel={planComparisonModalContent.prioritizedPlan}
        />
      )}
    </>
  )
}
